import { elements } from './elements.js';
import {
    bindSearchInput,
    bindFormFields,
    bindFormSubmission,
    resetAndFetchResults,
    bindClearAllButton
} from '../shared/singleSectionSearch.js';

export const bindFormElements = (fetchResults, updateQueryString, allChoices) => {
    const {
        searchForm,
        searchInput,
        regionRadios,
        formatSelect,
        yearSelect,
        genreSelect,
        availableToWatchCheckbox,
        clearAllButtons,
        clearSearchButton,
        searchButton
    } = elements;

    if (
        !searchForm ||
        !searchInput ||
        !regionRadios ||
        !formatSelect ||
        !yearSelect ||
        !genreSelect ||
        !availableToWatchCheckbox
    ) return;

    bindSearchInput(
        searchInput,
        () => resetAndFetchResults(fetchResults, updateQueryString, searchForm),
        clearSearchButton,
        searchButton
    );

    bindFormFields(
        [...regionRadios, formatSelect, yearSelect, genreSelect, availableToWatchCheckbox],
        () => resetAndFetchResults(fetchResults, updateQueryString, searchForm)
    );

    bindFormSubmission(
        searchForm,
        () => resetAndFetchResults(fetchResults, updateQueryString, searchForm)
    );

    clearAllButtons.forEach(clearAllButton => {
        bindClearAllButton(clearAllButton, searchForm, () => {
            Object.values(allChoices).forEach(choice => choice.setChoiceByValue(''));
            availableToWatchCheckbox.checked = false;

            resetAndFetchResults(fetchResults, updateQueryString, searchForm);
        });
    });
};
